import { useTheme } from '@emotion/react';
import GoogleIcon from '@mui/icons-material/Google';
import { Box, Button } from '@mui/material';
import { createElement, useEffect, useState } from 'react';
import { tokens } from '../../global/theme/tokens';
import useFetch from '../../api/useFetch';
import { Integration } from '../../scenes/employees/info-tabs/EmployeeIntegrations';
import ExoDialog from '../exo/ExoDialog';
import { useTranslation } from 'react-i18next';
import { API_POST, DBRequest, useConfig } from '../../api/api';

export const IntegrationsSyncIndicator = ({ type }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();
  const config = useConfig();

  const { apiData } = useFetch(`integrations`);

  const [actionRequired, setActionRequired] = useState(false);
  const [open, setOpen] = useState(false);

  const typeMap = {
    googleCalendar: {
      icon: GoogleIcon,
      description: t(
        'Synchronize your Google Calendar with ExoPaper and keep track of all your appointments. Thanks to the seamless integration, you can automatically include your meetings and events in other programs such as Outlook or the native calendar apps from Android and Apple - for optimal planning without duplicate entries.'
      ),
      image: '/assets/meeting-provider/google-calendar-logo.svg',
    },
  };

  useEffect(() => {
    if (!apiData) return;
    setActionRequired(
      apiData.data?.find((el) => el.type === type)?.actionRequired
    );
  }, [apiData]);

  function handleLogin(type) {
    const currentUrl = window.location.href;

    DBRequest({
      config,
      path: 'integrations',
      method: API_POST({ type, redirectUrl: currentUrl }),
      onResponse: (res) => openGoogleAuthPopup(res.data?.url),
    });
  }

  const openGoogleAuthPopup = (authUrl) => {
    const width = 500;
    const height = 600;
    const left = window.screenX + (window.innerWidth - width) / 2;
    const top = window.screenY + (window.innerHeight - height) / 2;

    window.location.href = authUrl;
  };

  if (!type || !apiData?.data?.find((el) => el.type === type)) return;

  return (
    <Box>
      <Button
        onClick={() => setOpen(true)}
        disabled={!actionRequired}
        sx={{
          display: actionRequired ? 'block' : 'none',
          margin: '0px',
          padding: '0px',
          bgcolor: colors.glass,
          ':hover': {
            bgcolor: colors.selected,
          },
          borderRadius: '8px',
          minWidth: '45px',
          height: '45px',
          border: '1px solid',
          //Remove false to add orange highlights
          borderColor: false && actionRequired ? colors.warning : 'transparent',
        }}
        className=" backdrop-blur-md h-[45px]"
      >
        {createElement(typeMap[type].icon, {
          //Remove false to add orange highlights
          color: false && actionRequired ? 'warning' : '',
        })}
      </Button>
      <ExoDialog open={open} limitWidth onClose={() => setOpen(false)}>
        <Integration
          className="mt-10"
          data={apiData?.data?.find((el) => el.type === type)}
          height="90%"
          description={typeMap[type].description}
          logo={typeMap[type].image}
          onLogout={() => {}}
          onLogin={handleLogin}
        />
      </ExoDialog>
    </Box>
  );
};
